import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { colors } from 'design-system';
import { useCallback } from 'react';

import { matchCurrentDate } from 'data-layer-cr/dist/functions/helpers';

import {
  EMITTED,
  PENDING_EMISSION,
  PENDING_INSPECTION,
  PROCESSING_EMISSION,
} from 'data-layer-cr/dist/constants/quotationStatus';

import { QuotationSummaryResponse } from 'data-layer-cr/dist/models';
import { ERROR_EMISSION } from 'src/constants/quotationStatus';

const useStyle = makeStyles(() => ({
  quotationStatusDisplay: {
    fontSize: 14,
    lineHeight: '28px',
    minWidth: 'max-content',
    minHeight: 28,
    borderRadius: 40,
    textTransform: 'none',
    fontWeight: 'bold',
    display: 'inline-block',
    color: colors.madison,
    paddingLeft: 12,
    paddingRight: 12,
    border: 1.5,
    borderStyle: 'solid',
  },
  pendingInspectionStatus: {
    background: `${colors.lightning_yellow}1A`,
    borderColor: colors.lightning_yellow,
    color: colors.lightning_yellow,
  },
  pendingEmissionStatus: {
    background: `${colors.onahau}4D`,
    borderColor: colors.madison,
    color: colors.madison,
  },
  emissionProcessStatus: {
    background: `${colors.abbey}1A`,
    borderColor: colors.abbey,
    color: colors.abbey,
  },
  emittedStatus: {
    background: `${colors.shamrock}1A`,
    borderColor: colors.shamrock,
    color: colors.shamrock,
  },
  expiredStatus: {
    background: `${colors.bright_pink}1A`,
    borderColor: colors.bright_pink,
    color: colors.bright_pink,
  },
  errorStatus: {
    background: '#FFEEF0',
    color: colors.bright_pink,
  },
}));

function parseStatus(
  statusName: string,
  expirationDate: string,
  statusId: number,
): string {
  if (matchCurrentDate(expirationDate) && statusId !== EMITTED) {
    return 'Vencida';
  }
  return statusName;
}

type StatusDisplayProps = {
  quotationSummary: QuotationSummaryResponse;
};

const StatusDisplay = ({
  quotationSummary,
}: StatusDisplayProps): JSX.Element => {
  const classes = useStyle();

  const getClassForStatus = useCallback(
    (status: number, expirationDate: string): string => {
      // first check if quotatin is expired
      if (matchCurrentDate(expirationDate) && status !== EMITTED) {
        return classes.expiredStatus;
      }
      switch (status) {
        case PENDING_INSPECTION:
          return classes.pendingInspectionStatus;
        case PENDING_EMISSION:
          return classes.pendingEmissionStatus;
        case PROCESSING_EMISSION:
          return classes.emissionProcessStatus;
        case ERROR_EMISSION:
          return classes.errorStatus;
        default:
          return classes.emittedStatus;
      }
    },
    [classes],
  );
  return (
    <div
      id="sales-web-div-statusdisplay"
      data-testid="status-display"
      className={clsx(
        classes.quotationStatusDisplay,
        getClassForStatus(
          quotationSummary.status.id,
          quotationSummary.expirationDate,
        ),
      )}
    >
      {parseStatus(
        quotationSummary.status.name,
        quotationSummary.expirationDate,
        quotationSummary.status.id,
      )}
    </div>
  );
};

export default StatusDisplay;
